const YT_HOSTS = new Set([
    "youtube.com", "www.youtube.com", "m.youtube.com",
    "youtu.be", "www.youtu.be", "music.youtube.com"
]);

function parseStartSeconds(u: URL): number {
    const t = u.searchParams.get("t") || u.searchParams.get("start");
    if (!t) return 0;
    if (/^\d+$/.test(t)) return parseInt(t, 10);
    const m = t.match(/(?:(\d+)h)?(?:(\d+)m)?(?:(\d+)s)?/i);
    if (!m) return 0;
    const h = parseInt(m[1] || "0", 10);
    const mm = parseInt(m[2] || "0", 10);
    const s = parseInt(m[3] || "0", 10);
    return h * 3600 + mm * 60 + s;
}

function extractYouTubeId(rawUrl: string): { id: string | null; start: number } {
    try {
        const u = new URL(rawUrl);
        if (!YT_HOSTS.has(u.hostname)) return { id: null, start: 0 };

        let id: string | null = null;
        const path = u.pathname.replace(/^\/+/, "");

        if (u.hostname.includes("youtu.be")) {
            id = path.split("/").filter(Boolean)[0] || null;
        } else {
            if (u.searchParams.get("v")) id = u.searchParams.get("v");
            else if (path.startsWith("shorts/")) id = path.split("/")[1] || null;
            else if (path.startsWith("embed/")) id = path.split("/")[1] || null;
        }
        const start = parseStartSeconds(u);
        return { id, start };
    } catch {
        return { id: null, start: 0 };
    }
}

function buildIframeHTML(id: string, start = 0): string {
    const qs = new URLSearchParams();
    if (start > 0) qs.set("start", String(start));
    qs.set("rel", "0");
    const src = `https://www.youtube-nocookie.com/embed/${id}?${qs.toString()}`;
    return `
    <div class="embed-youtube" data-youtube-id="${id}">
      <iframe
        src="${src}"
        title="YouTube video"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
        referrerpolicy="strict-origin-when-cross-origin"
        loading="lazy"
        sandbox="allow-same-origin allow-scripts allow-presentation"
      ></iframe>
    </div>
  `;
}

/**
 * HTML 문자열 내 유튜브 링크를 찾아 iframe으로 치환
 * - 단독 링크(문장 중간 강조 링크가 아닌 경우) 우선 치환
 * - 맨숫자 URL 단독 줄도 치환
 */
export function autoEmbedYouTubeHTML(html: string): string {
    // a태그 링크 → 임베드
    html = html.replace(
        /<a\b[^>]*href=["']([^"']+)["'][^>]*>(.*?)<\/a>/gi,
        (full, href: string, inner: string) => {
            const { id, start } = extractYouTubeId(href);
            if (!id) return full;
            const text = (inner || "").trim();
            const isBareLink = text === href || /^https?:\/\/(youtu\.be|(?:www\.)?youtube\.com)\//i.test(text);
            return isBareLink ? buildIframeHTML(id, start) : full;
        }
    );

    // 맨숫자 URL 단독 줄 → 임베드
    html = html.replace(
        /(^|\s|\r?\n)(https?:\/\/(?:www\.)?(?:youtube\.com|youtu\.be)\/[^\s<]+)(?=(\s|\r?\n|$))/gi,
        (full, pre: string, url: string, post: string) => {
            const { id, start } = extractYouTubeId(url);
            if (!id) return full;
            return `${pre}${buildIframeHTML(id, start)}${post}`;
        }
    );

    return html;
}
